// Headers that tell the API which app a request comes from. The token's appName claim is copied
// from the user's last login in ANY app, so a white-label app must say who it is on every call
// or the API filters its data by another app's name.
// Only the mobile apps set global.appNameLogin; web sends nothing and keeps the claim.
// appOs comes from the platform-split files (appOs.ios.js / appOs.android.js, picked by Metro),
// so this shared client never imports react-native, which the web apps don't bundle.
import { appOs } from './appOs';

export const appHeaders = () => {
  const { appNameLogin, appVersion } = globalThis;
  if (!appNameLogin) {
    return {};
  }
  return {
    appName: appNameLogin,
    ...(appVersion ? { appVersion } : {}),
    ...(appOs ? { appOs } : {}),
  };
};
